import { fromJS } from 'immutable';

const checkValidity = (state) => {
  const fields = [
    'startDate',
    'endDate',
    'deadlineDate',
    'taxId',
    'customizedMessage',
  ];
  return fields.reduce((oldState, field) => {
    if (oldState.get(field)) return oldState;
    return oldState.setIn(['errors', field, 'show'], true);
  }, state);
};

const updateFieldAndErrors = (state, { key, value }) => {
  if (value) {
    if (state.getIn(['errors', key, 'show'])) return state.set(key, value).setIn(['errors', key, 'show'], false);
    return state.set(key, value);
  }
  return state.set(key, value)
    .setIn(['errors', key, 'show'], true);
};

const updateDates = (state, { key, value }) => {
  const startDate = state.get('startDate');
  const endDate = state.get('endDate');
  // const deadlineDate = state.get('deadlineDate');
  if (key === 'startDate') {
    if (endDate) {
      if (value > endDate) {
        return state.set(key, value)
          .setIn(['errors', 'startDate', 'show'], true)
          .setIn(['errors', 'endDate', 'show'], true);
      }
      if (value <= endDate) {
        return state.set(key, value)
          .setIn(['errors', 'startDate', 'show'], false)
          .setIn(['errors', 'endDate', 'show'], false);
      }
    }
    // if (deadlineDate) {
    //   console.log('re-check');
    //   return updateDates(newState || state, {
    //     key: 'deadlineDate',
    //     value: deadlineDate,
    //   });
    // }
  }
  if (key === 'endDate') {
    if (startDate) {
      if (value < startDate) {
        return state.set(key, value)
          .setIn(['errors', 'startDate', 'show'], true)
          .setIn(['errors', 'endDate', 'show'], true);
      }
      if (value >= startDate) {
        return state.set(key, value)
          .setIn(['errors', 'startDate', 'show'], false)
          .setIn(['errors', 'endDate', 'show'], false);
      }
    }
  }
  if (key === 'deadlineDate') {
    if (startDate) {
      if (value > startDate) {
        return state.set(key, value)
          .setIn(['errors', 'deadlineDate', 'show'], true);
      }
      return state.set(key, value)
        .setIn(['errors', 'deadlineDate', 'show'], false);
    }
  }

  return state.set(key, value)
    .setIn(['errors', key, 'show'], false);
};

const initialStateObject = {
  creatingContracts: false,
  radioButtonValue: '',
  showAllContractPartners: false,
  submissionCriteria: '',
  notesRadioButtonValue: '',
  termsAndConditions: '',
  termsRadioButtonValue: '',
  submissionCriteriaCopyTemplateValue: 1,
  customizedMessage: '',
  subject: '',
  errors: {
    taxId: { show: false, errorText: 'Corporate identifier / tax id is required.' },
    termsAndConditions: { show: false, errorText: 'Terms & conditions is required.' },
    submissionCriteria: { show: false, errorText: 'This field is required.' },
    startDate: { show: false, errorText: 'Valid date range is required' },
    endDate: { show: false, errorText: 'Valid date range is required' },
    deadlineDate: { show: false, errorText: 'The deadline date must be a date prior to the start of the contracting period' },
  },
  buyerBCCSelf: false,
  includeNotes: false,
  assignTag: false,
  assignFolder: false,
};
const initialState = fromJS(initialStateObject);

function wizard(state = initialState, { type, payload }) {
  switch (type) {
    case 'UPDATE_PROPS_IN_CONTRACT_REQUEAST_WIZARD':
      return state.merge(fromJS(payload));
    case 'NOTES_RADIO_BUTTON_CHANGE':
      return state.set('notesRadioButtonValue', payload.value);
    case 'TERMS_RADIO_BUTTON_CHANGE':
      return state.set('termsRadioButtonValue', payload.value);
    case 'CREATE_CONTRACT_STARTING':
      return state.set('creatingContracts', !state.get('creatingContracts'));
    case 'CREATE_CONTRACT':
      return state.set('creatingContracts', false);
    case 'SUBMIT_COPY_SELECTION':
      return state.set(payload.templateType, payload.value);
    case 'SET_RADIO_BUTTON_VALUE':
      return state.set('radioButtonValue', payload);
    case 'ADD_SELECTED_CONNECTIONS':
      return state.setIn(['modals', 'selectFromUploadedConnections'], false)
        .setIn(['modals', 'selectFromExistingConnections'], false);
    case 'SHOW_ALL_CONTRACT_PARTNERS':
      return state.set('showAllContractPartners', payload);
    case 'ADD_CONTRACT_SETTINGS_UPDATE':
      if (new Set(['startDate', 'endDate', 'deadlineDate']).has(payload.key)) {
        if (payload.key === 'startDate' && state.get('deadlineDate')) {
          // console.log('double check');
          return updateDates(updateDates(state, payload), { key: 'deadlineDate', value: state.get('deadlineDate') });
        }
        return updateDates(state, payload);
      }
      return updateFieldAndErrors(state, payload);
    case 'ADD_CUSTOMIZED_MESSAGE':
      return state.set('customizedMessage', payload.value);
    case 'DISABLE_CONTINUE_AND_SHOW_ERRORS':
      return checkValidity(state);
    case 'SET_SUBMISSION_CRITERIA_COPY_TEMPLATE_DROPDOWN_VALUE':
      return state.set('submissionCriteriaCopyTemplateValue', payload);
    case 'CLEAR_CONTRACTOR_CONTRACTING_WIZARD':
      return fromJS({
        ...initialStateObject,
        taxId: state.get('taxId'),
        customizedMessage: state.get('customizedMessage'),
        ...payload,
      });
    case 'PROCESSING_ALL_CONTRACTING_PARTNERS':
      return state.set('processingPartners', !state.get('processingPartners'));
    case 'PROCESSED_ALL_CONTRACTING_PARTNERS':
      return state.set('processingPartners', false);
    default:
      return state;
  }
}

export default wizard;



// WEBPACK FOOTER //
// ./src/app/stores/contracting/wizard/wizard-reducer.js